import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, OnInit, Optional } from '@angular/core';
import { GridOptions } from '@app/core/components/grid/grid.types';
import { OrderLineItem } from '../order-head/order-lines-grid/order-lines-grid.component';
import { TT_VIEW_NAVIGATOR, TTViewNavigator } from '@app/modal/state-modal/state-modal.component';
import { OrderheadService, OrderHeadsGet } from '@app/services/orderhead.service';
import { Grid } from '@app/core/components/grid/grid.model';
import { RowSelectedEvent } from '@ag-grid-community/core';

@Component({
    selector: 'tt-order-heads',
    templateUrl: './order-heads.component.html',
    styleUrls: ['./order-heads.component.css'],
    standalone: false,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OrderHeadsComponent implements OnInit {
    public params?: GetOrderHeadsParams;

    public get?: OrderHeadsGet;

    public orderHeadsGrid?: GridOptions<OrderHeadGridRow>;

    public orderLinesGrid?: GridOptions<OrderLineItem>;

    public orderLinesParams?: { order_internal_no: string };

    constructor(
        private orderhead: OrderheadService,
        private cdr: ChangeDetectorRef,
        @Optional() @Inject(TT_VIEW_NAVIGATOR) private navigator?: TTViewNavigator,
    ) {}

    public onOrderHeadSelected(event: RowSelectedEvent) {
        if (!this.get) return;

        if (event.node.isSelected()) {
            const selectedOrderInternalNo = '' + (event.data as OrderHeadGridRow).order_internal_no;

            this.get.selected_order_internal_no = selectedOrderInternalNo;
            this.orderLinesParams = { order_internal_no: selectedOrderInternalNo };
            this.cdr.markForCheck();
        } else {
        }
    }

    private async loadGet() {
        if (!!this.params && 'argtype' in this.params && 'argvalue' in this.params) {
            this.get = await this.orderhead.getOrderHeadsPage({ ...this.params, webpage: `orderheads/${this.params.argtype}/${this.params.argvalue}` });
        }
    }

    public readOrderHeadsGrid() {
        if (!this.get) return;

        this.get.selected_order_internal_no = '0';
        this.orderLinesParams = undefined;
        this.orderLinesGrid = undefined;

        if (!this.orderHeadsGrid) {
            this.orderHeadsGrid = new Grid<OrderHeadGridRow>().setRememberId('w_orderheads_orderhead_grid').setLoadDataFunction({ method: 2852, parameters: () => ({ ...this.get, webpage: `orderheads/${this.params?.argtype}/${this.params?.argvalue}` }) });
        } else {
            this.orderHeadsGrid.gridfunc?.read();
        }
        this.cdr.markForCheck();
    }

    public onOrderHeadsGridReady() {
        this.orderHeadsGrid?.gridfunc?.selectRow(0);
    }

    private async init() {
        await this.loadGet();
        this.readOrderHeadsGrid();
        this.cdr.markForCheck();
    }

    ngOnInit(): void {
        if (!!this.navigator) {
            this.navigator.setSize?.({ width: '98vw', height: '95vh' });
            this.params = this.navigator.params as any;
            this.init();
        }
    }
}

interface GetOrderHeadsParams {
    argtype: string;
    argvalue: string;
}

interface OrderHeadGridRow {
    order_internal_no: number;
    order_order_no: number;
    order_offer_no: number;
    stat_cust_no: number;
    stat_cust_name: number;
    invoice_cust_no: number;
    invoice_cust_name: number;
    stat_coop_name: number;
    invoice_coop_name: number;
    item_glyphicon: number;
    item_glyphicon_color: number;
    item_state: number;
    item_parms: number;
    item_path: number;
    orderstatus_name: number;
    ordertype_name: number;
    ordermethod_name: number;
    order_date: number;
    customers_ref2: number;
    message_from_sales: number;
    message_to_supplier: number;
    po_keyno: number;
    products: number;
    total_amount1_locval: number;
    total_amount3_locval: number;
    estimated_cost_amount_locval: number;
    db: number;
    dg_pst: number;
    tax_keyno: number;
    tax_string: number;
    deliverydate_confirmed: number;
    customers_orderno: number;
    registered_date: number;
    customers_ref1: number;
    reg_by_portal_user_keyno: number;
    delivery_address: number;
    deliverymethod: number;
    volume: number;
    weight: number;
    colli_quantity: number;
    picklist_printed_ok: boolean;
    postplace_id_street: number;
    comunity: number;
    county: number;
    special_orderstatus: number;
    oh_verified: boolean;
    direct_purchase: number;
    orderlinecancelcause_name: number;
    orderhead_cancellation_note: number;
    company_name: number;
    seller_name: number;
    amount_brt_ordval: number;
    amount_topay_rest: number;
    label: number;
    invoice_chain: number;
    stockplace_id: number;
    stockplace_name: number;
    is_selected: boolean;
    stat_business_name: number;
    invoice_business_name: number;
    project_keyno: number;
    project_name: number;
    is_edi_order: boolean;
    freight_cost_ordval: number;
    freight_cost_ordval_agreed: number;
    note1: number;
    last_invoice_date: number;
}
